// extracted by mini-css-extract-plugin
export default {"main-header":"MainNavigation_main-header__+iYJN","main-nav":"MainNavigation_main-nav__yXwAx"};